module.exports = __webpack_public_path__ + "img/verkauf_kundenberatung.88c1b5f.svg";